import { memo } from 'react';
import type { NodeBounds } from '@/layout/types';
import type { Point } from '@/utils/geometry';

interface Props {
  sourceNodeBounds: NodeBounds;
  mousePosition: Point;
}

const GHOST_COLOR = '#818cf8';

export const ConnectionGhost = memo(function ConnectionGhost({
  sourceNodeBounds,
  mousePosition,
}: Props) {
  const fromX = sourceNodeBounds.centerX;
  const fromY = sourceNodeBounds.centerY;

  return (
    <line
      x1={fromX}
      y1={fromY}
      x2={mousePosition.x}
      y2={mousePosition.y}
      stroke={GHOST_COLOR}
      strokeWidth={1.5}
      strokeDasharray="6 4"
      strokeLinecap="round"
      style={{ pointerEvents: 'none' }}
    />
  );
});
